import { userCompanyList } from '@/services/api-v3/userCompany';
import { useState } from 'react';

export default () => {
  const [data, setData] = useState<API.UserCompanyPayloadDto[] | null>(null);
  const [valueEnum, setValueEnum] = useState<Record<string, string> | null>(null);
  const [valueOptions, setValueOptions] = useState<{ value: string; label: string }[]>([]);
  const fetch = async (params: Record<string, string | number | boolean>) => {
    const res = await userCompanyList({ pageSize: -1, filter: JSON.stringify({ ...params }) });
    setData(res.data);
    setValueEnum(
      res.data?.reduce(
        (pre: Record<string, string>, curr: API.UserCompanyPayloadDto) => ({
          ...pre,
          [curr.id]: `${curr.userName} / ${curr.phoneNumber}`,
        }),
        {},
      ),
    );
    setValueOptions(
      res.data?.map((item: API.UserCompanyPayloadDto) => ({
        value: item.id,
        label: `${item.userName} / ${item.phoneNumber}`,
      })),
    );
  };
  const reset = () => {
    setData(null);
    setValueEnum(null);
    setValueOptions([]);
  };
  return {
    fetch,
    reset,
    data,
    valueEnum,
    valueOptions,
  };
};
